/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod/v4';

export const itemParentIdResponseSchema = z.object({
  hasExternalKey: z.boolean(),
  id: z.int(),
  itemTypeId: z.int(),
  loopId: z.int(),
  matched: z.boolean(),
  parentId: z.int().nullish(),
  parentManagedByIntegration: z.boolean(),
});
